//
//
//
//
//
//
//
//
//

export default {
  name: "MediaVideoComponent",
  props: {
    src: {
      // 视频地址
      type: String,
      required: true,
    },
    poster: {
      // 下载时显示的图像
      type: String,
      required: true,
    },
  },
  data() {
    return {
      paused: true,
      iconSmall: false, // 是否显示小的播放按钮，播放按钮为图片大小的65%,但是如果65%超过150px则显示150px。
    };
  },
  methods: {
    /**
     * 切换视频模式(播放 暂停)
     */
    videoSwitch() {
      window.location.href = this.src;
    },
  },
  mounted() {
    this.iconSmall = this.$refs.container.clientHeight * 0.65 > 150;
  },
};



// WEBPACK FOOTER //
// ./src/components/media/Video.vue